<template>
<div>
  <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
    <el-row>
      <el-col :span="18">
        <el-form-item label="填写人" prop="respondent_name">
          <el-input placeholder="请输入" v-model="addEditForm.respondent_name"></el-input>
        </el-form-item>
<!--        <el-form-item label="人员类型" prop="respondent_type">-->
<!--          <el-select v-fixZoom v-model="addEditForm.respondent_type" filterable placeholder="请选择" style="width: 100%">-->
<!--            <el-option v-for="item in respondentTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="填写时间" prop="survey_date">
          <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.survey_date"
                          type="datetime" value-format="yyyy-MM-dd hh:mm:ss" placeholder="请选择">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="满意程度" prop="">
          <div style="width: 100%;">
            <div v-if="addEditForm.respondent_type === 2" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">服务内容</div>
              <div><el-rate v-model="addEditForm.service_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 2" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">体验感</div>
              <div><el-rate v-model="addEditForm.experience_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 2" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">安全性</div>
              <div><el-rate v-model="addEditForm.safety_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 2" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">便捷度</div>
              <div><el-rate v-model="addEditForm.convenience_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 2" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">餐饮及卫生</div>
              <div><el-rate v-model="addEditForm.canteen_rating"></el-rate></div>
            </div>

            <div v-if="addEditForm.respondent_type === 1" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">工作量</div>
              <div><el-rate v-model="addEditForm.workload_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 1" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">工作流程</div>
              <div><el-rate v-model="addEditForm.process_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 1" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">工作内容</div>
              <div><el-rate v-model="addEditForm.content_rating"></el-rate></div>
            </div>
            <div v-if="addEditForm.respondent_type === 1" style="width: 100%;height: 30px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px">工作便捷度</div>
              <div><el-rate v-model="addEditForm.facility_convenience_rating"></el-rate></div>
            </div>
            <div style="width: 100%;height: 60px;display: flex;align-items: center">
              <div style="width: 90px;text-align: right;margin-right: 10px;height: 60px">
                <div style="height: 25px">智慧养老整体</div>
                <div>满意度</div>
              </div>
              <div><el-rate v-model="addEditForm.support_rating"></el-rate></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="反馈内容" prop="">
          <el-input type="textarea" :rows="2" placeholder="请输入" v-model="addEditForm.notes"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <div style="width: 90px;margin: auto">
          <el-upload class="avatar-uploader" action="#" :auto-upload="false" :show-file-list="false"
                     :on-exceed="handleExceed" :before-upload="beforeUpload" :on-change="getFile"
                     list-type="picture" :file-list="fileList">
            <img v-if="addEditForm.photo_path" :src="addEditForm.photo_path" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div style="font-size: 16px;text-align: center;color: #409EFF">
          <span>图片</span>
        </div>
        <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式</span></div>
      </el-col>
    </el-row>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createsurvey, updatesurvey, uploadfile} from '../../../api/yanglaoyuan.js'

export default {
  name: 'addEditBack',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    surveyObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      respondentTypes: [
        {id: 1, name: '工作人员'},
        {id: 2, name: '老人/家属'}
      ],
      fileList: [],
      addEditForm: {
        id: 0,
        respondent_name: '',
        respondent_type: '',
        survey_date: '',
        workload_rating: 0,
        process_rating: 0,
        content_rating: 0,
        convenience_rating: 0,
        service_rating: 0,
        experience_rating: 0,
        safety_rating: 0,
        canteen_rating: 0,
        facility_convenience_rating: 0,
        support_rating: 0,
        notes: '',
        photo_path: ''
      },
      addEditRules: {
        respondent_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        respondent_type: [{required: true, message: '请选择', trigger: 'change'}],
        survey_date: [{ required: true, message: '请选择', trigger: 'change' }],
        workload_rating: [{ required: true, message: '请选择', trigger: 'change' }],
        process_rating: [{required: true, message: '请选择', trigger: 'change'}],
        content_rating: [{ required: true, message: '请选择', trigger: 'change' }],
        convenience_rating: [{ required: true, message: '请选择', trigger: 'change' }],
        service_rating: [{ required: true, message: '请选择', trigger: 'change' }],
        experience_rating: [{ required: true, message: '请选择', trigger: 'change' }],
        safety_rating: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    }
  },
  created () {
    this.addEditForm.respondent_type = this.surveyObj.respondent_type
    console.log(111, this.surveyObj)
    if (!this.surveyObj.isAdd) {
      this.addEditForm.id = this.surveyObj.row.id
      this.addEditForm.respondent_name = this.surveyObj.row.respondent_name
      this.addEditForm.respondent_type = this.surveyObj.row.respondent_type
      this.addEditForm.survey_date = this.surveyObj.row.survey_date
      this.addEditForm.workload_rating = this.surveyObj.row.workload_rating
      this.addEditForm.process_rating = this.surveyObj.row.process_rating
      this.addEditForm.content_rating = this.surveyObj.row.content_rating
      this.addEditForm.convenience_rating = this.surveyObj.row.convenience_rating
      this.addEditForm.service_rating = this.surveyObj.row.service_rating
      this.addEditForm.experience_rating = this.surveyObj.row.experience_rating
      this.addEditForm.safety_rating = this.surveyObj.row.safety_rating
      this.addEditForm.canteen_rating = this.surveyObj.row.canteen_rating
      this.addEditForm.facility_convenience_rating = this.surveyObj.row.facility_convenience_rating
      this.addEditForm.support_rating = this.surveyObj.row.support_rating
      this.addEditForm.notes = this.surveyObj.row.notes
      this.addEditForm.photo_path = this.surveyObj.row.photo_path
    }
  },
  methods: {
    // 图片
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        return
      }
      let obj = {
        raw: file.raw,
        filename: '头像',
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传', type: 'success' })
        this.addEditForm.photo_path = res.data.fileurl
      }).catch(() => {
        this.$message.closeAll()
        this.addEditForm.photo_path = ''
        this.imageUrl = ''
        this.$message({ message: '上传失败', type: 'error' })
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },

    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      let loginResp = this.$store.state.user.LoginResp
      let entityId = loginResp.entity_id
      console.log(this.addEditForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            respondent_name: this.addEditForm.respondent_name,
            respondent_type: this.addEditForm.respondent_type,
            survey_date: this.addEditForm.survey_date,
            workload_rating: this.addEditForm.workload_rating,
            process_rating: this.addEditForm.process_rating,
            content_rating: this.addEditForm.content_rating,
            convenience_rating: this.addEditForm.convenience_rating,
            service_rating: this.addEditForm.service_rating,
            experience_rating: this.addEditForm.experience_rating,
            safety_rating: this.addEditForm.safety_rating,
            canteen_rating: this.addEditForm.canteen_rating,
            facility_convenience_rating: this.addEditForm.facility_convenience_rating,
            support_rating: this.addEditForm.support_rating,
            notes: this.addEditForm.notes,
            photo_path: this.addEditForm.photo_path
          }
          console.log(data)
          if (this.surveyObj.isAdd) {
            data.eid = entityId
            createsurvey(data).then(res => {
              this.$notify({title: '成功', message: '成功新增', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            data.id = this.addEditForm.id
            updatesurvey(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditBack.vue